<template>
  <div class="password-step">
    <h2>Create Your Password</h2>
    <div class="form-group">
      <label>Create Your Password</label>
      <div class="password-input">
        <input
          :type="showPassword ? 'text' : 'password'"
          v-model="password"    
          autocomplete="new-password"
        />
        <button type="button" @click="toggleShow">
          {{ showPassword ? 'HIDE' : 'SHOW' }}
        </button>
      </div>

      <div class="requirements">
        <ul>
          <li :class="{ met: hasLetter }">• At least one letter</li>
          <li :class="{ met: hasNumber }">• At least one number</li>
          <li :class="{ met: isValidLength }">
            • Minimum 8 characters, Maximum 20 characters
          </li>
        </ul>
      </div>
    </div>

    <div class="step-footer">
      <span>Step 2 of 8</span>
      <button class="next-btn" @click="nextStep" :disabled="!isPasswordValid">
        NEXT
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordStep",
  emits: ["nextStep"],
  data() {
    return {
      password: "",
      showPassword: false,
    };
  },
  computed: {
    hasLetter() {
      return /[a-zA-Z]/.test(this.password);
    },
    hasNumber() {
      return /\d/.test(this.password);
    },
    isValidLength() {
      return this.password.length >= 8 && this.password.length <= 20;
    },
    isPasswordValid() {
      return this.hasLetter && this.hasNumber && this.isValidLength;
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    nextStep() {
      this.$emit("nextStep", {
        password: this.password,
      });
    },
  },
};
</script>

<style scoped>
.password-step {
  max-width: 500px;
  margin: 0 auto;
  display: grid;
  grid-template-rows: 1fr 8fr 1fr;

  h2 {
    border-bottom: SOLID 1PX #E0E0E0;
  }
}

.form-group {
  padding-top: 1.5%;
}

.password-input {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
  border: solid 1px grey;
  border-radius: 5px;

}

input[type="password"],
input[type="text"] {
  padding: 8px;
  font-size: 16px;
}

button {
  padding: 8px 14px;
  cursor: pointer;
}

.requirements ul {
  list-style: none;
  padding-left: 0;
}

.requirements li {
  color: #888;
}

.requirements li.met {
  color: #8adbdb;
  font-weight: bold;
}

.next-btn {
  background-color: #42C0C0;
  color: white;
  border: none;
}

.next-btn:disabled {
  background-color: #8adbdb;
  cursor: not-allowed;
  opacity: 0.6;
}

.step-footer {
  display: grid;
  grid-template-columns: 4fr 1fr;
  border-top: SOLID 1PX #E0E0E0;
  padding: 5px 0;

  span {
    padding-top: 2%;
  }
}
.password-input {
  display: flex;
  align-items: center;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  overflow: hidden;
  transition: border 0.2s ease;
}

.password-input:focus-within {
  border: 2px solid #42c0c0;

}
.password-input input:focus-visible{
  box-shadow:none
}
/* Input field */
.password-input input {
  flex: 1;
  padding: 10px;
  font-size: 16px;
  border: none;
  outline: none;
  background: white;
}

/* Show/Hide button */
.password-input button {
  padding: 10px 16px;
  border: none;
  background: white;
  font-weight: bold;
  cursor: pointer;
  height: 100%;
  outline: none;
}
</style>
